export const FLOW_MODAL_TEXT = {
	cancel: 'Cancel',
	back: 'Back',
	continue: 'Continue',
	confirm: 'Confirm',
};
